import React from 'react';
import { ArrowUp, ArrowDown } from 'lucide-react';

const KpiCard = ({ title, value, valueFormatted, change, trend, percentage }) => {
  return (
    <div className="bg-white rounded-lg shadow-sm p-6">
      <div className="text-gray-500">{title}</div>
      <div className="mt-2 flex items-end">
        <div className="text-3xl font-bold text-blue-900">
          {valueFormatted || value}
        </div>
        {change !== undefined && (
          <div 
            className={`ml-2 text-sm font-medium ${
              trend === 'up' ? 'text-green-600' : 'text-red-600'
            }`}
          >
            {trend === 'up' ? '+' : ''}{change}%
          </div>
        )}
      </div>
      
      <div className="text-sm text-gray-500 mb-4">vs mês anterior</div>
      
      {percentage !== undefined && (
        <div className="h-2 bg-gray-200 rounded-full">
          <div 
            className={`h-2 ${
              trend === 'up' ? 'bg-green-500' : 'bg-red-500'
            } rounded-full`}
            style={{ width: `${percentage}%` }}
          ></div>
        </div>
      )}
    </div>
  );
};

export default KpiCard;